import { createTRPCClient, httpLink } from "@trpc/client";
import superjson from "superjson";
import Config from "../../common/config";

export const createSwagClient = (headers = {}) =>
  createTRPCClient({
    links: [
      httpLink({
        url: Config.getSwagURL(),
        transformer: superjson,
        headers: () => headers,
      }),
    ],
  });
